import { Box, Grid2, Typography } from '@mui/material';

import { ColorPicker } from 'src/components/NodeSaleForm/ColorPicker';
import { colors } from 'src/global/styles/colors';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { SectionAccordion } from './SectionAccordion';

export function ThemeReferralSection() {
  const { theme, updateTheme } = useTheme();
  return (
    <Box padding={'12px 24px 24px 24px'} borderBottom={`1px solid ${colors.neutral015}`}>
      <SectionAccordion
        title='Referral Hero Section'
        bodyContent={
          <Box width={'100%'}>
            <Grid2 container width={'100%'} spacing={3}>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Fill Color
                </Typography>
                <Box width={'100%'} marginTop={2}>
                  <ColorPicker
                    color={theme.theme.referralHeroSection.color}
                    onColorChange={color => {
                      updateTheme({
                        ...theme,
                        theme: {
                          ...theme.theme,
                          referralHeroSection: { ...theme.theme.referralHeroSection, color: color },
                        },
                      });
                    }}
                    opacity={theme.theme.referralHeroSection.colorOpacity}
                    onOpacityChange={opacity => {
                      updateTheme({
                        ...theme,
                        theme: {
                          ...theme.theme,
                          referralHeroSection: { ...theme.theme.referralHeroSection, colorOpacity: opacity / 100 },
                        },
                      });
                    }}
                  />
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        }
      />
    </Box>
  );
}
